import { render, staticRenderFns } from "./LanguageOptions.vue?vue&type=template&id=af1e21fe&scoped=true&"
import script from "./LanguageOptions.vue?vue&type=script&lang=ts&"
export * from "./LanguageOptions.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageOptions.vue?vue&type=style&index=0&id=af1e21fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1e21fe",
  null
  
)

export default component.exports